import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { WEB_ROUTES } from "../../constants";
import { getToken } from "../../Data/services/localStorageService";
import { baseRoute } from "../../Helper";

function ProtectedRoute({ children }) {
  const token = getToken();
  return token ? (
    children
  ) : (
    <Navigate to={baseRoute(WEB_ROUTES.ACCOUNT)} replace />
  );
}

/** Agent portal: only admin screens should be reachable; others redirect to dashboard. */
export function AdminOnlyRoute({ children }) {
  const portal = useSelector((state) => state.auth?.portal);
  if (portal === "agent") {
    return <Navigate to={baseRoute(WEB_ROUTES.DASHBOARD)} replace />;
  }
  return children;
}

export default ProtectedRoute;
